import { all } from 'redux-saga/effects';

import ErrorHandler from 'helpers/ErrorsHelpers';

import { watchRefreshAccessToken } from '../../commons/reduxModules/Authentication';

import { watch as watchInitCmpApp } from './initCmpAppSaga';
import { watch as watchOpenCmpModal } from './openCmpModalSaga';
import { watch as watchCloseCmpModal } from './closeCmpModalSaga';
import { watch as watchSetCookie } from './setCookieSaga';
import { watch as watchSetCookieGroup } from './setCookieGroupSaga';
import { watch as watchAcceptAllCookies } from './acceptAllCookiesSaga';
import { watch as watchRefuseAllCookies } from './refuseAllCookiesSaga';
import { watch as watchAcceptAllFromBanner } from './acceptAllFromBannerSaga';
import { watch as watchRejectAllFromBanner } from './rejectAllFromBannerSaga';
import { watch as watchSetGlobalCookiePreferences } from './setGlobalCookiePreferencesSaga';
import { watch as watchSetCookieTimer } from './setCookieTimerSaga';
import { watch as watchReloadPage } from './reloadPageSaga';
import { watch as watchSetGroupCollapsedStatus } from './setGroupCollapsedStateSaga';
import { watch as watchInitAnalyticsFront } from './initAnalyticsFrontSaga';
import { watch as watchInitAnalyticsPro } from './initAnalyticsProSaga';
import { watch as watchDeleteCookies } from './deleteCookiesSaga';
import { watch as watchHandleWidgetCookies } from './handleWidgetCookiesSaga';

const errorHandler = new ErrorHandler();

function* rootSaga() {
    try {
        yield all([
            watchRefreshAccessToken(),
            // App
            watchInitCmpApp(),
            watchOpenCmpModal(),
            watchCloseCmpModal(),
            watchSetCookie(),
            watchSetCookieGroup(),
            watchAcceptAllCookies(),
            watchRefuseAllCookies(),
            watchAcceptAllFromBanner(),
            watchRejectAllFromBanner(),
            watchSetGlobalCookiePreferences(),
            watchSetCookieTimer(),
            watchReloadPage(),
            watchSetGroupCollapsedStatus(),
            watchInitAnalyticsFront(),
            watchInitAnalyticsPro(),
            watchDeleteCookies(),
            watchHandleWidgetCookies(),
        ]);
    } catch (e) {
        errorHandler.handleError(e);
    }
}

export default rootSaga;
